export const isVSCodeRequest = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('vscode') === 'true';
};

export const redirectToVSCode = (token, user) => {
    const vscodeRedirectUri = `vscode://extension-id/auth-success?token=${token}&user=${JSON.stringify(user)}`;
    window.location.href = vscodeRedirectUri;
};

export const handleAuthErrors = (error) => {
  if (error.response && error.response.data) {
    const { detail } = error.response.data;
    if (detail === 'Expired access token' || detail === 'Invalid access token') {
      // Clear local storage and redirect to sign-in page
      localStorage.clear();
      window.location.href = '/vscode/signin';
    }
  }
  throw error;
};
